import React, { useEffect, useState, useRef, useContext } from 'react';
import { IonItem, IonButton, IonSlides, IonGrid, IonTabs, IonTab, IonTabBar, IonTabButton, IonToolbar, IonTitle, IonContent, IonHeader, IonLabel, IonRouterOutlet, IonFooter, IonCard, IonModal, IonLoading, IonText, IonInfiniteScroll, IonInfiniteScrollContent } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonImg } from '@ionic/react';
import { useHistory} from "react-router-dom";

import '../css/zPublic.css';
import '../../css/layout.css';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';
import { MerchantLoginCredentials } from '../components/LoginCredentials_merchant';
import { Reservation_EnterBookingInfo } from './Reservation_EnterBookingInfo_locals';
import { Enlarge_Image } from './EnlargeImage';
import { ViewProductDetailDataModal_Public } from './Modal_Product_Details_Public';
import { Modal_Checkout_Retail } from './Modal_Checkout_Retail';
import {CachedImage} from './Component_CachedImage'; // Import CachedImage component


export function Retail_Homepage (props) {

        let authMerchant_objects = useContext(Auth_MerchantID_context);

        let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);


        let [customerRating, setCusotmerRating] = useState('0.00000');
        let [viewHotelRooms_showcase, setViewHotelRooms_showcase] = useState([]);

        let [merchantLoginModal, setMerchantLoginModal] = useState(false);
        let [showProductDetails, setShowProductDetails] = useState(false);
        let {enlargeImageModal, setEnlargeImageModal} = useState(false);

        let [productID, setProductID] = useState(props.data.productID);
        let [image, setImage] = useState(null);
        let [openCheckoutModal, setOpenCheckoutModal] = useState(false);

        let [isloading, setLoading] = useState(false);


        const PAGE_SIZE = 5;         // how many images to show at a time
        let [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
        let [hasMore, setHasMore] = useState(true);
        const [imageErrors, setImageErrors] = useState({});
        
        let history = useHistory();

        let currentShowcaseCategoryRef = useRef('main');


        let merchant_ID = props.data.companyId;



        useEffect(() => {

            //setLoading(true);



            setViewHotelRooms_showcase([]);

            let requestOptions3= {
                method: 'POST',
                credentials: 'include',
                headers: {'content-type': 'application/json' },
                body: JSON.stringify({
                    Tracker: "0002AA_retail",
                    merchantID: merchant_ID,
                    xShowcaseCategory: currentShowcaseCategoryRef.current.value
                }),
            }

            fetch(baseURL+'merchants_argsApp', requestOptions3)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                        setViewHotelRooms_showcase((prevViewHotelRooms_showcase) => {
                            return prevViewHotelRooms_showcase.concat({
                                productID: cols[0], 
                                productName: cols[1], 
                                salePrice: cols[2], 
                                image1: cols[3],
                                image2: cols[4],
                                image3: cols[5],
                                image4: cols[6],
                                qtyAvailable: cols[7], 
                                publicPrice: cols[8],

                            })
                        });

                }

                //setLoading(false);
                setVisibleCount(PAGE_SIZE);
                setHasMore(true);
            });

        }, [])


        function enterProductDetailsModalHandler(event) 
        {


            setProductID(event[1]);
            setImage(event[2]);
            //setEnlargeImageModal(event[0]);
            setShowProductDetails(event[0]);

        }


        const handleHomepage = () => {

            if(authMerchant_objects.authenticated == 'T3')
            {
                history.push('/retail_merchantMainPageApp'); 
                window.location.href = '/retail_merchantMainPageApp';
            }
      };

        //alert('In Homepage_retail');
        //alert(props.data.mtnCompanyPhoneNumber);
        //alert(undefined);
        //alert([]);

       // alert(showcase_optionCategories.length);

            return (
                <React.Fragment>
                <IonModal isOpen={true}>
                    <IonHeader>
                        <IonGrid >
                            <IonRow className='gh_homepage_top_links_row'>
                                <IonCol className='zPub_list_gridCol_title' style={{ textAlign: 'center' }}>{props.data.companyName}</IonCol>

                                <IonCol className='gh_homepage_top_links_col' size='3' style={{ textAlign: 'right' }}>
                                    {authMerchant_objects.authenticated == null && <IonButton  className='small_button' onClick={() => setMerchantLoginModal(true)}> Login </IonButton>}
                                    {authMerchant_objects.authenticated != null && <IonButton  className='small_button' onClick={() => handleHomepage()}> Homepage </IonButton>}
                                </IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol className='zPub_list_gridCol_address'>{props.data.companyAddressNumber + " " + props.data.companyStreetName+" * "+props.data.companyCity + ", " +props.data.companyCityDistrict}</IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol className='zPub_list_gridCol_address'>{props.data.companyEmail+" * "+props.data.companyPhoneNumber}</IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>
                    {viewHotelRooms_showcase.length === 0 ? (
                    <div className='zList_companyImage_list'>
                        <IonCard className='card_merchantList'>
                        <div className='zList_img'>
                            <div className="dot-loader">
                            <span className="dot"></span>
                            <span className="dot"></span>
                            <span className="dot"></span>
                            <span className="dot"></span>
                            </div>
                        </div>
                        </IonCard>
                    </div>
                    ) : (

                        <IonContent className='merchantList_Content_showcase'>
                        <div className='zShowcase_list'>

                                        {viewHotelRooms_showcase
                                        .slice(0, visibleCount)
                                        .map((detailData) => {  

                                        if (imageErrors[detailData.image]) {
                                        return null;
                                        }

                                        return (
                                            <IonCard className='card_merchantList_showcase' onClick={ () => enterProductDetailsModalHandler([true, detailData.productID, detailData.image])}>
                                                {/*<IonGrid className='showcase_grid_price_qty'>
                                                    <IonRow className= 'showcase_row_price_qty'>
                                                        <IonCol>
                                                            <IonText>Price: {parseFloat(detailData.salePrice).toFixed(2)}</IonText>
                                                        </IonCol>
                                                        <IonCol>
                                                            <IonText>Stock: {detailData.qtyAvailable}</IonText>
                                                        </IonCol>
                                                    </IonRow>
                                                </IonGrid>*/}
                                                <div style={{
                                                    fontSize: "1.8em",
                                                    fontWeight: "bold",
                                                    textAlign: "center",
                                                    marginBottom: "15px"
                                                }}>
                                                    {detailData.productName}
                                                </div>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    gap: "15px",
                                                    marginBottom: "10px"
                                                }}>
                                                    <div style={{ 
                                                        fontSize: '1.5em', 
                                                        fontWeight: 'bold', 
                                                        color: '#ff5722',
                                                        backgroundColor: '#fff3e0',
                                                        padding: '10px 15px', 
                                                        borderRadius: '10px',
                                                        textAlign: 'center'
                                                    }}>
                                                        Price: GHS {parseFloat(detailData.publicPrice).toFixed(2)}
                                                    </div>

                                                    <div style={{ 
                                                        fontSize: '1.5em', 
                                                        fontWeight: 'bold', 
                                                        color: '#388e3c',
                                                        backgroundColor: '#e8f5e9',
                                                        padding: '10px 15px', 
                                                        borderRadius: '10px',
                                                        textAlign: 'center'
                                                    }}>
                                                        Stock: {detailData.qtyAvailable}
                                                    </div>
                                                </div>
                                            
                                                <div className='zShowcase_img_div_retail'>
                                                    <div className='zShowcase_img_slider'>
                                                    { detailData.image1 != 'null' && 
                                                    <img
                                                        src={detailData.image1}
                                                        className="zShowcase_img_inside"
                                                        alt="Hotel Image"
                                                        loading="lazy"
                                                        onError={() => {
                                                            setImageErrors(prev => ({
                                                                ...prev,
                                                                [detailData.image1]: true
                                                            }));
                                                        }}
                                                    />}

                                                    { detailData.image2 != 'null' && 
                                                    <img
                                                        src={detailData.image2}
                                                        className="zShowcase_img_inside"
                                                        alt="Hotel Image"
                                                        loading="lazy"
                                                        onError={() => {
                                                            setImageErrors(prev => ({
                                                                ...prev,
                                                                [detailData.image2]: true
                                                            }));
                                                        }}
                                                    />}

                                                    { detailData.image3 != 'null' && 
                                                    <img
                                                        src={detailData.image3}
                                                        className="zShowcase_img_inside"
                                                        alt="Hotel Image"
                                                        loading="lazy"
                                                        onError={() => {
                                                            setImageErrors(prev => ({
                                                                ...prev,
                                                                [detailData.image3]: true
                                                            }));
                                                        }}
                                                    />}

                                                    { detailData.image4 != 'null' && 
                                                    <img
                                                        src={detailData.image4}
                                                        className="zShowcase_img_inside"
                                                        alt="Hotel Image"
                                                        loading="lazy"
                                                        onError={() => {
                                                            setImageErrors(prev => ({
                                                                ...prev,
                                                                [detailData.image4]: true
                                                            }));
                                                        }}
                                                    />}

                                                        {/*
                                                        { detailData.image1 != 'null' && <IonImg src={`/api/image/${detailData.image1}/${props.data.companySchema}`} />}
                                                        { detailData.image2 != 'null' && <IonImg src={`/api/image/${detailData.image2}/${props.data.companySchema}`} />}
                                                        { detailData.image3 != 'null' && <IonImg src={`/api/image/${detailData.image3}/${props.data.companySchema}`} />}
                                                        { detailData.image4 != 'null' && <IonImg src={`/api/image/${detailData.image4}/${props.data.companySchema}`} />}
                                                        */}
                                                    </div>

                                                </div>

                                            </IonCard>
                        );
                                    })}

                        </div>

                        <IonInfiniteScroll
                            onIonInfinite={(ev) => {
                            const newCount = visibleCount + PAGE_SIZE;

                            if (newCount >= viewHotelRooms_showcase.length) {
                                setVisibleCount(viewHotelRooms_showcase.length);
                                setHasMore(false);
                            } else {
                                setVisibleCount(newCount);
                            }

                            ev.target.complete();
                            }}
                            disabled={!hasMore}
                        >
                            <IonInfiniteScrollContent
                            loadingSpinner="bubbles"
                            loadingText="Loading more rooms..."
                            />
                        </IonInfiniteScroll>
                                        
                        {isloading == true && <IonLoading
                                                isOpen={isloading}
                                                message={'Please wait...'}
                                                duration={0} // Show until manually dismissed
                                            />}

                        </IonContent>
                    )}
                    <IonFooter class='hotelShowcaseFooter'>
                    <IonGrid>
                        <IonRow >
                            <IonCol size='6'>
                                <IonButton onClick={() => setOpenCheckoutModal(true)}>Checkout</IonButton>
                            </IonCol>
                            {/*<IonCol size='4'>
                                <IonButton href='https://bluefinhoteltest.com'>Site</IonButton>
                            </IonCol>*/}
                            <IonCol size='6'>
                                <IonButton onClick={() => props.closeModal()}>Close</IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                    </IonFooter>

                   {merchantLoginModal == true && <MerchantLoginCredentials openModal={ merchantLoginModal } closeModal={() => setMerchantLoginModal(false)} ></MerchantLoginCredentials>}

                </IonModal>


                {enlargeImageModal == true && <Enlarge_Image openModal={ enlargeImageModal } closeModal={() => setEnlargeImageModal(false)} data={{
                                                                    companyID: props.data.companyId,
                                                                    productID: productID, 
                                                                    //image: image,
                                                                    }} ></Enlarge_Image>}

                {showProductDetails == true &&   <ViewProductDetailDataModal_Public openModal={ showProductDetails } closeModal={() => setShowProductDetails(false)} data={{
                        status: props.data.status,
                        companyId: props.data.companyId,
                        companySchema: props.data.companySchema,
                        companyPhoneNumber: props.data.companyPhoneNumber,
                        mtnCompanyPhoneNumber: props.data.mtnCompanyPhoneNumber,
                        productID: productID, 
                        }}></ViewProductDetailDataModal_Public> }

                {openCheckoutModal == true &&   <Modal_Checkout_Retail openModal={ openCheckoutModal } closeModal={() => setOpenCheckoutModal(false)} data={{
                        status: props.data.status,
                        companyId: props.data.companyId,
                        companyPhoneNumber: props.data.companyPhoneNumber,
                        mtnCompanyPhoneNumber: props.data.mtnCompanyPhoneNumber,
                    }}></Modal_Checkout_Retail> }
                        
            </React.Fragment>
    
            )
        //}


    }
